// extracted by mini-css-extract-plugin
export default {"Option":"fE0Z5Vlb","Content":"iXAWf2wo"};